import { 
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom'
import Home from './pages/home'

const router = createBrowserRouter([
  {
    path: '/:oid',
    element: <Home />,
  }
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
